import { Link } from "react-router";

import { USER_SPACE_PATHS } from "@/client/pages/client/user-space/config/navigation";
import { useAccountCurrency } from "@/client/services/currency/currency";

type Props = {
  onNavigate?: () => void;
};

export const AccountCurrencyNote = ({ onNavigate }: Props) => {
  const { context } = useAccountCurrency();

  return (
    <p className="flex flex-wrap items-center justify-center gap-x-1.5 text-center text-xs leading-5 text-slate-500">
      <span>
        Prix affichés en{" "}
        <strong className="font-bold text-[#071451]">{context?.currency ?? "…"}</strong>, la devise
        de votre pays.
      </span>

      <Link
        to={USER_SPACE_PATHS.settings}
        className="font-semibold text-indigo-600 underline-offset-2 hover:underline"
        onClick={onNavigate}
      >
        Modifier mon pays
      </Link>
    </p>
  );
};
